import React from 'react';
import CtaButton from '../../../../components/elements/CtaButton';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import { SectionPaddingSide, SectionPaddingVertical } from '../../../../components/global/Layout';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { getVariantWaysToCodeData } from './waysToCodeData';
import ImageTextCard, {
  CardBody,
  CardContent,
  CardTitle,
  CardImage,
} from '../../../../components/elements/ImageTextCard';

const styles = require('./WaysToCode.module.css');
const CTA_DATA_LOCATION = 'ways_to_code';

function Card({ image, title, text }) {
  return (
    <ImageTextCard>
      <CardImage src={image} alt={title} />

      <CardContent className={styles.wayToCodeCardBody}>
        <CardTitle variant="h4" className={styles.wayToCodeCardTitle}>
          {title}
        </CardTitle>

        <CardBody variant="body2">{text}</CardBody>
      </CardContent>
    </ImageTextCard>
  );
}

function WaysToCode({ onCtaClick, title, backgroundColor, ctaLabel, ways }) {
  const handleCtaClick = e => {
    onCtaClick(e, CTA_DATA_LOCATION);
  };

  return (
    <SectionPaddingVertical style={{ backgroundColor }}>
      <SectionPaddingSide>
        <CodeSparkThemedTypography variant="h2" className={styles.waysToCodeHeader}>
          {title}
        </CodeSparkThemedTypography>

        <div className={`grid-x grid-margin-x ${styles.waysToCodeContent}`}>
          {ways.map((codingMethod, i) => {
            return <Card key={`way_to_code_${i}`} {...codingMethod} />;
          })}
        </div>

        <CtaButtonContainer className={styles.waysToCodeCtaContainer}>
          <CtaButton
            type="primary"
            data-event-action="homepage-three-ways-to-code"
            data-event-label={ctaLabel}
            onClick={handleCtaClick}
          >
            {ctaLabel}
          </CtaButton>
        </CtaButtonContainer>
      </SectionPaddingSide>
    </SectionPaddingVertical>
  );
}

function WaysToCodeVariant({ variant, ...props }) {
  const waysToCodeData = getVariantWaysToCodeData(variant);
  return <WaysToCode {...props} {...waysToCodeData} />;
}

export default WaysToCodeVariant;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/WaysToCode/index.js